import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.DealEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.DealCreate })));
const list = lazy(() => import("./List").then(m => ({ default: m.DealList })));

export default { edit, create, list };
